// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportList-cls1_KLw","cls2":"ReportList-cls2_MCb ReportList-cls1_KLw"};